var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { FormSpy } from 'react-final-form';
import { propFunc, propShape } from '../../../../helpers/custom-prop-types';
/**
 * FormSpyのラッパーコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FinalFormSpy = (props) => {
    const { onChange: rawOnChange, subscription } = props;
    const onChange = useCallback((formSpyProps) => __awaiter(void 0, void 0, void 0, function* () {
        // warning回避
        setTimeout(() => {
            rawOnChange(formSpyProps);
        }, 0);
    }), [rawOnChange]);
    return _jsx(FormSpy, { onChange: onChange, subscription: subscription });
};
FinalFormSpy.propTypes = {
    onChange: propFunc().isRequired,
    subscription: propShape(),
};
FinalFormSpy.defaultProps = {
    subscription: {
        dirty: true,
        error: true,
        errors: true,
        pristine: true,
        submitErrors: true,
        submitFailed: true,
        submitting: true,
        touched: true,
        valid: true,
        validating: true,
        values: true,
    },
};
export default FinalFormSpy;
